<template>
  <div class="login_box">
    <div class="div_img">
      <img class="login_logo" src="../../assets/logo.png" />
    </div>
    <el-form>
      <div class="login_form">
        <h2 style="text-align:center">{{webTitle}}</h2>
        <el-form-item  prop="account">
          <input
            type="text"
            class="ic_user login_user"
            placeholder="手机号"
            maxlength="11"
            name="account"
            show-word-limit
            v-model="loginForm.account"
          />
        </el-form-item>
          <el-form-item prop="password">
        <div>
          <input
            type="text"
            class="ic_password login_pwd"
            placeholder="验证码"
            maxlength="6"
             name="password"
            oninput="value=value.replace(/[^\d]/g,'')"
            v-model="loginForm.password"
          />
        </div>

        <el-button
          :disabled="sendAuthCode"
          type="primary"
          @click.native.native="getAuthCode"
        >获取验证码{{auth_time}}</el-button>
        </el-form-item>
        <div>
          <!-- <el-checkbox class="ic_rember" style="float:left">记住密码</el-checkbox> -->
          <el-button size="small" class="login_btn" @click.native.native="login" type="primary">登录</el-button>
        </div>
        <div>
          <el-button size="small" class="wx_login_btn">企业微信授权登录</el-button>
        </div>
        <span style="float:left">
          没有账号？
          <a href="#">注册公司</a>
        </span>
      </div>
    </el-form>
  </div>
</template>

<script>
export default {
  name: 'login',
  data () {
    return {
      loginForm: {
        account: '',
        password: ''
      },
      isBtnLoading: false,
      sendAuthCode: false, // 启用
      auth_time: ''
    }
  },
  created () {
    // if (JSON.parse(localStorage.getItem('user')) && JSON.parse(localStorage.getItem('user')).account) {
    //   this.account = JSON.parse(localStorage.getItem('user')).account
    //   this.password = JSON.parse(localStorage.getItem('user')).password
    // }
  },
  computed: {
    btnText () {
      if (this.isBtnLoading) return '登录中...'
      return '登录'
    }
  },
  methods: {
    login () {
      if (!this.loginForm.account) {
        this.$message.error('请输入手机号')
        return
      }
      // else if (this.loginForm.account !== '5') {
      //   this.$message.error('手机号码必须是数字nnn')
      //   return
      // } else if (!Number.isInteger(this.loginForm.account)) {
      //   this.$message.error('手机号码必须是数字')
      //   return
      // }
      if (!this.loginForm.password) {
        this.$message.error('请输入验证码')
        return
      }
      this.$router.replace('/main')
    },
    //  验证
    getAuthCode () {
      if (this.loginForm.account.length !== 11) {
        this.$message.error('请输入正确的手机号码')
        return
      }
      const url = ''
      console.log('ur', url)
      this.sendAuthCode = true // 禁用
      // 设置倒计时秒
      this.auth_time = 10
      var authTimeTimer = setInterval(() => {
        this.auth_time--
        if (this.auth_time <= 0) {
          this.auth_time = ''
          this.sendAuthCode = false // 启用
          clearInterval(authTimeTimer)
        }
      }, 1000)
    },
  }
}
</script>

<style scoped lang="scss" rel="stylesheet/scss">
@import "~@/style/theme.scss";

.login_box {
  /* border: 1px solid #dcdfe6; */
  width: 600px;
  margin: 180px auto;
  padding: 65px;
  border-radius: 5px;
  -moz-border-radius: 5px;
  -webkit-border-radius: 20px;
  box-shadow: 0 0 25px #dcdee2;
}
.div_img {
  float: left;
  background-color: red;
}
.login_logo {
  position: absolute;
  margin: auto;
  height: 50px;
}
.login_form {
  padding-top: 1%;
  padding-left: 40%;
  padding-right: 10%;
}
.ic_user {
  background: url("../../assets/login/ic_user.png") no-repeat;
  background-size: 13px 15px;
  background-position: 3%;
}
.ic_password {
  background: url("../../assets/login/ic_password.png") no-repeat;
  background-size: 13px 15px;
  background-position: 3%;
  margin-bottom: 20px;
  margin-right: 3px;
  float: left;
}
.ic_rember {
  width: 100%;
  font-size: 16px;
  margin-bottom: 15px;
  text-align: left;
}
.login_btn {
  width: 100%;
  font-size: 14px;
  margin-bottom: 15px;
  background: -webkit-linear-gradient(
    left,
    $maincolor,
    #2154fa
  ); /* Safari 5.1 - 6.0 */
  background: -o-linear-gradient(
    right,
    $maincolor,
    #2154fa
  ); /* Opera 11.1 - 12.0 */
  background: -moz-linear-gradient(
    right,
    $maincolor,
    #2154fa
  ); /* Firefox 3.6 - 15 */
  background: linear-gradient(to right, $maincolor, #2154fa); /* 标准的语法 */
  /* filter: brightness(1.4); */
}
.wx_login_btn {
  width: 100%;
  font-size: 14px;
  margin-bottom: 15px;
  margin-left: 0px;
}

.login_user {
  height: 40px;
  width: 90%;
  margin-top: 2px;
  margin-bottom: 5px;
  padding-left: 10%;
  border: 0;
  border-bottom: solid 1px lavender;
}

.login_pwd {
  height: 40px;
  width: 47%;
  margin-bottom: 5px;
  padding-left: 10%;
  border: 0;
  border-bottom: solid 1px lavender;
}

</style>



// WEBPACK FOOTER //
// src/views/login/login.vue